import ContentLoader from 'react-content-loader';

const WIDTH = 768;
const HEIGHT = 165;
const PADDING = 24;

const shapes = [
	{ x: PADDING, y: PADDING, w: 370, h: 15, r: 10 },
	{ x: PADDING, y: PADDING + 23, w: 290, h: 15, r: 10 },
	{ x: PADDING, y: PADDING + 46, w: 246, h: 7, r: 10 },
	{ x: WIDTH - PADDING - 86, y: PADDING, w: 86, h: 32, r: 10 },
	{ x: WIDTH - PADDING - 86, y: PADDING + 47, w: 86, h: 11, r: 10 },
	{ x: WIDTH - PADDING - 143, y: HEIGHT - PADDING - 41, w: 143, h: 41, r: 10 },
];

function DealLoader({ isRtl }) {
	return (
		<div className="deals-wrapper hotel-deal">
			<ContentLoader width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} rtl={isRtl}>
				{shapes.map((s, i) => (
					<rect key={i} x={s.x} y={s.y} width={s.w} height={s.h} rx={s.r} ry={s.r} />
				))}
			</ContentLoader>
		</div>
	);
}

export default DealLoader;
